import { ServiceClient } from 'src/utils'
import {
    Bordero,
    BorderoEnvio as BorderoEnvioRemessa,
    ResultadoAnalise,
    ResultadoDetalhadoBordero,
    RetornoEnvioBordero,
    StatusProcessamentoBordero
} from './bordero.types'

const serviceClient = ServiceClient.singleton()

export class BorderoService {
    static #INSTANCE = new BorderoService()
    static readonly singleton = () => BorderoService.#INSTANCE

    async fetchBorderos(dataInicial: Date, dataFinal: Date, status?: string, borderoId?: number) {
        return serviceClient.authGet<Bordero[]>(
            `/api/v1/bordero?dataInicial=${dataInicial}&dataFinal=${dataFinal}${status ? `&status=${status}` : ''}${
                status ? `&borderoId=${borderoId}` : ''
            }`
        )
    }

    async deleteBordero(borderoId: number) {
        return serviceClient.authDelete(`/api/v1/bordero/${borderoId}`)
    }

    async fetchResultadosBorderos(borderoId: number) {
        return serviceClient.authGet<ResultadoAnalise[]>(`/api/v1/bordero/resultado/${borderoId}`)
    }

    async fetchResultadoDetalhadoBordero(borderoId: number) {
        return serviceClient.authGet<ResultadoDetalhadoBordero>(`/api/v1/bordero/resultado-detalhado/${borderoId}`)
    }

    async fetchStatusProcessamentoBordero(borderoId: number) {
        return serviceClient.authGet<StatusProcessamentoBordero[]>(`/api/v1/bordero/status-processamento/${borderoId}`)
    }

    async reprocessBordero(id: number) {
        const response = await serviceClient.authPost<RetornoEnvioBordero>(`/api/v1/bordero/reprocessar/${id}`)
        return response
    }

    async saveRemessaBordero(remessa: BorderoEnvioRemessa) {
        const response = await serviceClient.authPost<RetornoEnvioBordero>(`/api/v1/bordero-envio/envio`, remessa)
        return response
    }
}

export default BorderoService.singleton()
